var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-month-picker',{attrs:{"placeholder":"Chọn tháng","value":_vm.monthMoment,"format":_vm.monthFormat,"allowClear":false,"locale":_vm.locale},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }